import React, { useEffect } from 'react';
import { Shield, Award, Globe, Users, ArrowRight } from 'lucide-react';
import { companyData } from '../mockData';
import { Link } from 'react-router-dom';

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="dark-page defense-page">
      {/* About Hero */}
      <section className="defense-hero" style={{ minHeight: '70vh' }}>
        <div className="defense-hero-content" style={{ padding: '100px 0' }}>
          <div style={{ maxWidth: '1000px' }}>
            <div className="classification-badge" style={{ marginTop: '20px' }}>ABOUT US</div>
            <h1 className="defense-headline" style={{ fontSize: '72px', marginTop: '24px' }}>{companyData.name}</h1>
            <h2 className="defense-subheadline" style={{ marginTop: '20px' }}>Defending Critical Assets Through Innovation</h2>
            <p className="defense-description" style={{ maxWidth: '900px', marginTop: '40px' }}>
              {companyData.mission}
            </p>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="capabilities-section">
        <div className="capabilities-grid">
          {companyData.stats.map((stat, index) => (
            <div key={index} className="capability-card">
              <div className="capability-metric">{stat.value}</div>
              <div className="capability-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Story */}
      <section className="configs-section">
        <div className="section-tag">OUR STORY</div>
        <h2 className="section-title-large">Founded in {companyData.founded}</h2>
        
        <div style={{ maxWidth: '1200px', margin: '60px auto 0' }}>
          <p style={{ fontSize: '18px', lineHeight: '1.8', color: 'rgba(255, 255, 255, 0.85)' }}>
            {companyData.story}
          </p>
          
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '40px', marginTop: '60px' }}>
            <div style={{ padding: '32px', background: '#000000', border: '1px solid rgba(212, 175, 55, 0.2)' }}>
              <div className="section-tag">FOUNDED</div>
              <div style={{ fontSize: '32px', fontWeight: '700', color: '#D4AF37', marginTop: '12px' }}>{companyData.founded}</div>
            </div>
            <div style={{ padding: '32px', background: '#000000', border: '1px solid rgba(212, 175, 55, 0.2)' }}>
              <div className="section-tag">HEADQUARTERS</div>
              <div style={{ fontSize: '32px', fontWeight: '700', color: '#D4AF37', marginTop: '12px' }}>{companyData.headquarters}</div>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="capabilities-section" style={{ background: '#0A0A0A' }}>
        <div className="section-tag">CORE VALUES</div>
        <h2 className="section-title-large">Principles That Drive Us</h2>
        
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '40px', maxWidth: '1400px', margin: '0 auto' }}>
          {companyData.values.map((value, index) => {
            const icons = [Shield, Award, Globe, Users];
            const Icon = icons[index] || Shield;
            
            return (
              <div key={index} style={{ padding: '48px 40px', background: '#000000', border: '1px solid rgba(212, 175, 55, 0.2)', transition: 'all 0.3s ease' }}>
                <div style={{ width: '64px', height: '64px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(212, 175, 55, 0.1)', marginBottom: '24px' }}>
                  <Icon size={32} style={{ color: '#D4AF37' }} />
                </div>
                <h3 className="capability-label" style={{ fontSize: '18px', marginBottom: '16px' }}>{value.title}</h3>
                <p className="capability-desc">{value.description}</p>
              </div>
            );
          })}
        </div>
      </section>

      {/* Team */}
      <section className="capabilities-section">
        <div className="section-tag">LEADERSHIP & EXPERTISE</div>
        <h2 className="section-title-large">Our Team</h2>
        
        <div style={{ maxWidth: '1200px', margin: '60px auto 0', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', gap: '60px' }}>
          <div style={{ padding: '40px', background: '#0A0A0A', border: '1px solid rgba(212, 175, 55, 0.2)' }}>
            <h3 className="section-title-medium" style={{ fontSize: '24px', marginBottom: '20px' }}>Leadership Team</h3>
            <p style={{ fontSize: '16px', lineHeight: '1.8', color: 'rgba(255, 255, 255, 0.85)' }}>
              {companyData.team.leadership}
            </p>
          </div>

          <div style={{ padding: '40px', background: '#0A0A0A', border: '1px solid rgba(212, 175, 55, 0.2)' }}>
            <h3 className="section-title-medium" style={{ fontSize: '24px', marginBottom: '20px' }}>Technical Expertise</h3>
            <p style={{ fontSize: '16px', lineHeight: '1.8', color: 'rgba(255, 255, 255, 0.85)' }}>
              {companyData.team.expertise}
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="final-cta-section">
        <div className="final-cta-content">
          <h2 className="cta-headline">Join Our Mission</h2>
          <p className="cta-subtext">
            Partner with Labana Dynamics to protect your critical assets.
          </p>
          <div className="cta-buttons">
            <Link to="/contact" className="btn-primary-large">
              <span>Get in Touch</span>
              <ArrowRight size={20} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
